<template>
  <div class='query-result'>
      <div class="result-title" style="margin-bottom:20px;">
          <span style="margin-top:10px;display:inline-block">验真结果</span>
          <div class="back" @click="SET_HASRESULT(false)">
              <img src="../../../assets/icons/md-navigate_left.svg" alt=""><a>返回</a>
          </div>
      </div>
      <div class="result-content">
          <a-alert
          v-if="(new Date(checkresult[0].endTime).getTime())<(new Date().getTime())"
            message="该证书已过期"
            type="error"
            show-icon
        />
          <div class="cert-top">
              <a-table :data-source="checkresult" rowKey="id" :pagination="false">
                   <a-table-column key="userName" title="姓名" data-index="userName" width="100px" align="center"/>
                   <a-table-column key="cardNumber" title="身份证号" data-index="cardNumber" align="center" />
                   <a-table-column key="companyName" title="合作伙伴" data-index="companyName" :ellipsis="true" align="center" />
                   <a-table-column key="certificateTypeName" title="证书类型" data-index="certificateTypeName" width="100px" align="center"/>
                   <a-table-column key="subjectName" title="考试科目" data-index="subjectName" width="130px" align="center" />
                   <a-table-column key="beginTime" title="考试时间" width="150px" align="center" >
                     <template v-slot="scope">
                       <span>
                         {{$filters.timeToDate(scope.text.beginTime)}}
                       </span>
                     </template>
                   </a-table-column>
                    <a-table-column key="score" title="考试成绩" data-index="score" width="100px" align="center" />
                    <a-table-column key="certificateNumber" title="证书编号" data-index="certificateNumber" align="center" />
                    <a-table-column key="endTime" title="证书过期时间" width="150px" align="center" >
                      <template v-slot="scope">
                          <span>
                              {{$filters.timeToDate(scope.text.endTime)}}
                          </span>
                        </template>
                    </a-table-column>
              </a-table>
          </div>
          <div class="cert-bottom">
              <img :src="checkresultimage" alt="" style="width:900px">
          </div>
      </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex"
import {selectCertificateImage} from "../../../request/certificate"
import moment from "moment"
export default {
  name: '',
  props: {},
  data() {
    return {
      certificateNumber:"",
    };
  },
  computed: {
      ...mapGetters({
        checkresult:"certificate/checkresult",
        checkresultimage:"certificate/checkresultimage",
        hasResult:"certificate/hasResult",
      }),
      examtime(data){
        return 
      }
      
  },
  created(){
  },
  async mounted(){
      let token = localStorage.getItem("token")
      ? JSON.parse(localStorage.getItem("token"))
      : "";
      this.certificateNumber = this.checkresult[0].certificateNumber
  },
  watch: {},
  methods: {
      ...mapMutations({
          SET_HASRESULT:"certificate/SET_HASRESULT"
      }),
      moment
  },
  components: {},
  filters: {}
};
</script>
<style lang='scss' scoped>
.result-title{
  position: relative;
}
.result-title .back{
  position: absolute;
  right: 8px;
  top: 5px;
  font-size: 14px;
  cursor: pointer;
  img{
    width: 30px;
  }
  a{
    vertical-align: baseline;
  }
}
.result-content{
    display: flex;
    flex-direction: column;
    
}
.result-content .cert-top{
        width: 100%;
        min-width: 1300px;
    }
    .result-content .cert-bottom{
        margin:auto;
    }
    .ant-alert{
        width: 150px;
        margin: 10px auto;
    }
</style>
